import { toast } from "sonner";
import { CheckCircle, XCircle, AlertTriangle, Info, X } from "lucide-react";
import { isDarkModeEnabled } from "../features/themeSelect/themeUtils";

const typeConfig = {
  success: {
    Icon: CheckCircle,
    borderColor: { light: "#10b981", dark: "#34d399" },
    iconColor: { light: "#10b981", dark: "#34d399" },
  },
  error: {
    Icon: XCircle,
    borderColor: { light: "#ef4444", dark: "#f87171" },
    iconColor: { light: "#ef4444", dark: "#f87171" },
  },
  warning: {
    Icon: AlertTriangle,
    borderColor: { light: "#f59e0b", dark: "#fbbf24" },
    iconColor: { light: "#f59e0b", dark: "#fbbf24" },
  },
  info: {
    Icon: Info,
    borderColor: { light: "#3b82f6", dark: "#60a5fa" },
    iconColor: { light: "#3b82f6", dark: "#60a5fa" },
  },
};

export const triggerSnackbar = (message, type = "info") => {
  const config = typeConfig[type] || typeConfig.info;
  const dark = isDarkModeEnabled();
  const borderColor = dark ? config.borderColor.dark : config.borderColor.light;
  const iconColor = dark ? config.iconColor.dark : config.iconColor.light;
  const Icon = config.Icon;

  toast.custom(
    (id) => (
      <div
        className="flex items-start gap-3 w-full bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 border border-slate-200 dark:border-slate-700 shadow-lg rounded-lg px-4 py-3"
        style={{ borderLeft: `4px solid ${borderColor}` }}
      >
        <Icon
          className="mt-0.5 shrink-0"
          size={16}
          style={{ color: iconColor }}
        />
        <span className="flex-1 text-sm leading-snug">{message}</span>
        <button
          onClick={() => toast.dismiss(id)}
          className="ml-2 -mt-0.5 flex-shrink-0 rounded p-0.5 text-slate-400 hover:text-slate-700 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
          aria-label="Close"
        >
          <X size={14} />
        </button>
      </div>
    ),
    { duration: 15000 },
  );
};
